
var toSpace = require('to-space-case')

/**
 * Export.
 */

module.exports = toSlugCase

/**
 * Convert a `string` to slug case.
 *
 * @param {String} string
 * @return {String}
 */

function toSlugCase(string) {
  return toSpace(string).replace(/\s/g, '-')
}



//////////////////
// WEBPACK FOOTER
// ../~/to-case/~/to-slug-case/index.js
// module id = 3046
// module chunks = 0